import { c as _c } from "react/compiler-runtime";
import type { EntityBankAccount } from '@onefootprint/types';
import { Select } from '@onefootprint/ui';
export type BankAccountSelectorProps = {
  selected?: EntityBankAccount;
  onChange: (item: EntityBankAccount) => void;
  bankAccounts: EntityBankAccount[];
};
export const BankAccountSelector = t0 => {
  const $ = _c(9);
  const {
    selected,
    onChange,
    bankAccounts
  } = t0;
  let t1;
  if ($[0] !== bankAccounts || $[1] !== onChange) {
    t1 = newValue => {
      const newItem = bankAccounts.find(item => item.alias === newValue);
      if (newItem) {
        onChange(newItem);
      }
    };
    $[0] = bankAccounts;
    $[1] = onChange;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  const t2 = selected?.alias || "";
  let t3;
  if ($[3] !== bankAccounts) {
    t3 = bankAccounts.map(_temp);
    $[3] = bankAccounts;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleChange || $[6] !== t2 || $[7] !== t3) {
    t4 = <Select value={t2} onChange={handleChange} options={t3} size="compact" className="w-full" />;
    $[5] = handleChange;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default BankAccountSelector;
function _temp(bankAccount) {
  return {
    value: bankAccount.alias || "",
    label: bankAccount.alias || ""
  };
}